var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomerSegments({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.7052 32.2948H0C0 15.8891 13.2995 2.5896 29.7052 2.5896V32.2948Z",
    fill: "#CCE5FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7052 32.2948L29.7052 62C13.2995 62 0 48.7005 0 32.2948H29.7052Z",
    fill: "#DADFF3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7057 32.2948H59.4109C59.4109 48.7005 46.1114 62 29.7057 62L29.7057 32.2948Z",
    fill: "#28345A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2948 29.7052L32.2948 0C48.7005 0 62 13.2995 62 29.7052L32.2948 29.7052Z",
    fill: "#027BC7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerSegments);
export default __webpack_public_path__ + "static/media/customerSegments.16c9e265a1818b524f2a2998599cae30.svg";
export { ForwardRef as ReactComponent };